import { render, staticRenderFns } from "./InsertButton.vue?vue&type=template&id=4eb38376&scoped=true"
import script from "./InsertButton.vue?vue&type=script&lang=js"
export * from "./InsertButton.vue?vue&type=script&lang=js"
import style0 from "./InsertButton.vue?vue&type=style&index=0&id=4eb38376&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb38376",
  null
  
)

export default component.exports